import React from 'react';
import { Box } from '@mui/material';
import { CssTextField } from 'components/select';
import { OrderPayload } from 'pages/myidm/store';
import { useRecoilValue } from 'recoil';
import PropTypes from 'prop-types';

const ADGroupOwner = ({ index = 0 }) => {
    const order = useRecoilValue(OrderPayload);
    // Get the owner value based on index
    let ownerValue = '';
    if (order?.multipleAdGroups && order.multipleAdGroups.length > index) {
        const ownerObj = order.multipleAdGroups[index]?.adGroupOwner;
        if (ownerObj && typeof ownerObj === 'object' && ownerObj.gpid && ownerObj.name) {
            ownerValue = `${ownerObj.gpid} - ${ownerObj.name}`;
        } else if (ownerObj && typeof ownerObj === 'object' && ownerObj.name) {
            ownerValue = ownerObj.name;
        } else if (typeof ownerObj === 'string') {
            ownerValue = ownerObj;
        }
    }
    return (
        <Box display="flex" alignItems="center" gap={1} data-testid="ad-group-owner-box">
            <CssTextField
                size="small"
                fullWidth
                autoComplete="off"
                label="Active Directory Group Owner *"
                placeholder="Active Directory Group Owner"
                value={ownerValue}
                disabled
            />
        </Box>
    );
};

ADGroupOwner.propTypes = {
    index: PropTypes.number.isRequired,
};

export default ADGroupOwner;
